/* global process */
let base = window._env_.VUE_APP_ROBOT_CALL_HOST
export const getIntelligentOutboundCallTable = params => {
  return axios.post(`${base}/admin/calltask/list`, params)
}
export const getIntelligentOutboundCallDetail = params => {
  return axios.get(`${base}/admin/calltask/${params.id}`, params)
}
export const getIntelligentOutboundCallDetailTable = params => {
  return axios.post(`${base}/admin/calldetail/list`, params)
}
export const exportCallDetailData = params => {
  return axios.post(`${base}/admin/calldetail/export`, params)
}
export const exportIntelligentOutboundCallData = params => {
  return axios.get(`${base}/exportIntelligentOutboundCallData/${params.id}`, {params})
}
export const createIntelligentOutboundCallData = params => {
  return axios.post(`${base}/admin/calltask`, params)
}
export const updateIntelligentOutboundCallData = params => {
  return axios.post(`${base}/admin/calltask/${params.id}`, params.formData)
}
export const deleteIntelligentOutboundCallData = params => {
  return axios.post(`${base}/deleteIntelligentOutboundCallData/${params.id}`, params)
}
export const robotCallqueryBatchUpload = params => {
  return axios.post(`${base}/admin/batch-jobs/list`, params)
}

export const startCallTask = params => {
  return axios.put(`${base}/admin/calltask/${params.id}/status/started`, params)
}

export const suspendCallTask = params => {
  return axios.put(`${base}/admin/calltask/${params.id}/status/suspended`, params)
}

export const importCallDetailAdd = params => {
  return axios.post(`${base}/admin/calldetail/import/add`, params)
}

export const importCallDetailChange = params => {
  return axios.post(`${base}/admin/calldetail/import/update`, params)
}

export const robotCalldownSourceFile = id => {
  return `${base}/admin/batch-jobs/${id}/source.xlsx`
}
export const robotCalldownErrorFile = id => {
  return `${base}/admin/batch-jobs/${id}/error.xlsx`
}

export const robotcallSetting = params => {
  return axios.post(`${base}/admin/settings`, params)
}

export const getIntelligentOutboundCallRecordTable = params => {
  return axios.post(`${base}/admin/calldetail/${params.id}/records`, params)
}



// WEBPACK FOOTER //
// ./src/views/intelligent-outbound-call/intelligent-outbound-call.api.js